module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/de/snipes-4343eb1e5a728082c7f5d24db9505a2f.jpg";